import React from 'react';
function Icon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path d="M628.769-94.617L472.616-250.768l42.153-42.153 114 114L855.538-405.69l42.153 42.152L628.769-94.616zM480-520l313.846-200H166.154L480-520zm0 62.306L160-662.309v410q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462H371l59.999 59.999h-258.69q-30.308 0-51.308-21t-21-51.308v-455.382q0-30.308 21-51.308t51.308-21h615.382q30.308 0 51.308 21t21 51.308v185.539L800-462.154v-200.155L480-457.694zm0 6.539zM480-520zm0 62.306z"></path>
    </svg>;
}
export default Icon;